<template>
  <eg-b-dropdown
    ref="filterDropdowns"
    class="essay-actions-dropdown mr-3"
    :class="{ active }"
    menu-class="filter-dropdown-menu"
    :disabled="disabled"
    no-caret
    :right="right"
    variant="outline-secondary"
    boundary="window"
    size="sm"
  >
    <template #button-content>
      <slot name="button-content">
        <div class="d-flex align-items-center">
          {{ buttonLabel }}
          <div v-if="active && selectedCount" class="selected-count mx-1">
            {{ selectedCount }}
          </div>
          <eg-b-icon class="fs-10 ml-1" icon="chevron-down"></eg-b-icon>
        </div>
      </slot>
    </template>
    <div class="filter-content-wrapper d-flex flex-column">
      <div class="filter-content-wrapper-content d-flex">
        <slot
          :reset-signal="resetSignal"
          :selected="selected"
          :placeholder="placeholder"
        />
      </div>
      <div
        v-if="$listeners.apply || $listeners.delete"
        class="filter-content-wrapper-actions d-flex align-items-center justify-content-between"
      >
        <eg-button
          v-if="$listeners.delete"
          size="small"
          class="ml-1 text-dark"
          type="ordinary"
          @click="deleteFilter"
        >
          {{ deleteLabel }}
        </eg-button>

        <eg-button
          v-if="$listeners.apply"
          size="small"
          class="ml-1"
          type="primary"
          @click="applyFilter"
        >
          {{ $t("common.apply") }}
          <span v-if="selectedCount">({{ selectedCount }})</span>
        </eg-button>
      </div>
    </div>
  </eg-b-dropdown>
</template>

<script>
export default {
  name: "FilterDropdown",

  props: {
    buttonLabel: {
      type: String,
      default: "",
    },

    title: {
      type: String,
      default: "",
    },

    selected: {
      type: [String, Number, Object, Array],
      default: () => [],
    },

    active: {
      type: Boolean,
      default: false,
    },

    right: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: "Search",
    },
    deleteLabel: {
      type: String,
      default: "Delete filter",
    },
  },

  data() {
    return {
      resetSignal: 0,
    };
  },
  computed: {
    selectedCount() {
      if (!Array.isArray(this.selected)) {
        return this.active ? 1 : false;
      }

      return this.selected?.length || 0;
    },
  },
  methods: {
    closeDropdown() {
      // NOTE: because of filterDropdowns.show() inside wrapped to requestAnimationFrame
      // if fast openDropdown then closeDropdown will not work without requestAnimationFrame
      requestAnimationFrame(() => {
        // in some case component destroyed inside requestAnimationFrame, then just ignore
        this.$refs?.filterDropdowns?.hide();
      });
    },

    openDropdown() {
      this.$refs.filterDropdowns.show();
    },

    applyFilter() {
      this.$emit("apply");
      this.closeDropdown();
    },

    deleteFilter() {
      this.$emit("delete");
      this.resetSignal++;
      this.closeDropdown();
    },
  },
};
</script>

<style lang="scss" scoped>
.filter-content-wrapper {
  min-width: 340px;
  max-width: 400px;
  width: max-content;
}

.selected-count {
  display: flex;
  width: 14px;
  height: 14px;
  padding: 0;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: var(--radius-rd-200, 4px);
  background: var(--color-surface-primary-default, #8a3ffc);
  outline: 2px solid var(--color-surface-primary-default, #8a3ffc);
  color: var(--color-text-on-surface-default, #fff);
  text-align: center;
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-100);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-600, 600);
  line-height: 140%;
}

.filter-content-wrapper-content:not(:has(.datepicker)) {
  overflow: auto;
}

.filter-content-wrapper-actions {
  padding: 8px 12px;
  border-top: 1px solid var(--color-stroke-neutral-default);
}

.essay-actions-dropdown::v-deep > .btn {
  padding: 8px 0.5rem;
  line-height: var(--typography-font-size-fs-300, 14px);
}
.essay-actions-dropdown::v-deep > .btn > div {
  gap: 0.25rem;
}
.essay-actions-dropdown::v-deep > .btn {
  background: var(--color-surface-neutral-container-1, #f6f8fa);
  border: 1px solid var(--color-stroke-neutral-default);
  font-size: var(--typography-font-size-fs-300);
  &:hover {
    border: 1px solid var(--color-stroke-neutral-hover);
  }
}

.essay-actions-dropdown::v-deep .btn:focus {
  box-shadow: none;
  text-decoration: none;
  outline: 2px solid var(--color-stroke-primary-focus);
}

.essay-actions-dropdown.show::v-deep > .btn,
.essay-actions-dropdown.active::v-deep > .btn {
  color: var(--color-text-neutral-on-white, #1c0f30);
  border-color: transparent;
  background: var(--color-surface-neutral-press, #ede5ff);
}

.essay-actions-dropdown.show::v-deep > .dropdown-toggle {
  border-color: var(--color-stroke-primary-default, #8a3ffc);
}

.export-dropdown {
  border-radius: 4px;
  background: var(--brand-secondary, #f3e8fc);

  &::v-deep {
    .btn {
      border-color: transparent;
    }
  }
}
</style>

<style lang="scss">
.dropdown-menu.filter-dropdown-menu.show {
  display: flex;
}
</style>
